
const ENV_DATA = require('./env.config.json');

let selectedEnv = getEnv(detectEnvironment());

/**
 * Sets the environment
 * @param {string} envName - The name of the environment.
 */
export default function setupEnv(envName) {
    const env = ENV_DATA[envName.toUpperCase()];
    if (!env) {
        throw new Error(`Setting undefined environment "${envName}".`);
    }

    selectedEnv = env;
}

/**
 * Returns the environment data.
 * @param {string} envName - The name of the environment.
 * @return {object}
 */
export function getEnv(envName) {
    return envName ? ENV_DATA[envName.toUpperCase()] : selectedEnv;
}

/**
 * Returns the detected environment name.
 * @return {string}
 */
function detectEnvironment() {
    let rv;

    const locUrl = new URL(window.location.href);
    switch (locUrl.hostname) {
        case 'apps.dev.nuskin.io':
            rv = 'APP-MANAGER';
            break;
        case 'dev.nuskin.com':
        case 'test.nuskin.com':
            rv = 'TEST';
            break;
        case 'localhost':
            switch (locUrl.port) {
                case '6006':
                    rv = 'STORYBOOK';
                    break;
                default:
                    rv = 'DEV';
            }

            break;
        default:
            rv = 'PROD';
    }

    if (rv !== 'PROD') {
        const params = new URLSearchParams(window.location.search);
        rv = params.get('environment') ? params.get('environment').toUpperCase() : rv;
    }

    return rv;
}
